import React from "react";

const FullScreenLoader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="loader-overlay">
      <div className="loader-spinner">
        <div className="spinner" />
      </div>
    </div>
  );
};

export default FullScreenLoader;
